var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "video",
    {
      attrs: {
        id: "trailer-player",
        playsinline: "",
        autoplay: "",
        poster: _vm.poster
      },
      domProps: { muted: _vm.isMuted }
    },
    _vm._l(_vm.videoSources, function(source) {
      return _c("source", {
        key: source.src,
        attrs: { src: source.src, type: source.type }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }